export default __webpack_public_path__ + "static/media/Devanture_1.4808152f.jpg";